module.exports = __webpack_public_path__ + "bf31f2b80313e5fd307e06c3778bf1ae.pdf";